import { Image, Text, Box, Heading, Flex, Button } from "@chakra-ui/react";
import { format } from "date-fns";
import Head from "next/head";
import { IoIosArrowBack } from "react-icons/io";
import { cmsBaseLink, fetchWordPressPosts, getWpImage } from ".";

export default function Post({
  content,
  image,
  title,
  thumb,
  date,
  formattedDate,
}: {
  content: string;
  image: string;
  title: string;
  thumb: string;
  date: string;
  formattedDate: string;
}) {
  return (
    <>
      <Head>
        <title>{`${title} | Talkio AI`}</title>
        <meta property="og:title" content={title} key="title" />
        <meta property="og:image" content={thumb} key="image" />
      </Head>

      <Box minH="800px" bg="white">
        <Flex gap={5} justifyContent={"center"}>
          <Box maxW="1072px">
            <Box
              backgroundColor="#eee"
              bgImage={`url('${image}')`}
              bgPosition="center"
              bgSize="cover"
              bgRepeat="no-repeat"
              w={"100%"}
              maxW="1072px"
              mt={5}
              mb={5}
              marginLeft="auto"
              marginRight="auto"
              height={{ base: "200px", md: "350px" }}
              position="relative"
            >
              <Flex
                opacity={0.7}
                _hover={{ opacity: 0.5 }}
                alignItems={"center"}
                as="a"
                href="/blog"
                position={"absolute"}
                m={2}
              >
                <IoIosArrowBack fontSize="sm" />
                <Box fontSize="xs" lineHeight={1} ml={1} fontWeight="bold">
                  Back
                </Box>
              </Flex>
            </Box>
            <Box mt={8} w="full" maxWidth={"800px"} backgroundColor="#fff" mx={"auto"} px={5}>
              <Heading as="h1" mb={0} fontSize="3xl" lineHeight={1.2}>
                {title}
              </Heading>
              <Text fontSize={"xs"} mt={1} color="brand.gray.400">
                Last updated on <time dateTime={date}>{formattedDate}</time>
              </Text>

              <Box
                mt={5}
                mb={12}
                className="markdown"
                dangerouslySetInnerHTML={{ __html: content }}
              ></Box>
            </Box>
          </Box>
          <Box display={{ base: "none", lg: "block" }} mt={5}>
            <Box w="260px"></Box>
            <Flex
              flexDir="column"
              alignItems={"center"}
              maxW="250px"
              p={5}
              bg="brand.blue.900"
              color="white"
            >
              <Text textAlign={"center"} as="h3" fontWeight={"bold"} fontSize="2xl">
                Talk Your Way <br />
                <Box as="span" color="brand.primary.main">
                  to Fluency
                </Box>
              </Text>
              <Image
                my={3}
                maxW="150px"
                src="/images/landing/alt-header.png"
                alt="Talkio Mobile Screenshot"
              />
              <Text mb={3} fontSize="xs" textAlign="center">
                Talkio is the ultimate language training app that uses AI technology to help you
                improve your oral language skills!
              </Text>
              <Button
                w="full"
                mt={4}
                as="a"
                href="/"
                colorScheme="brand.primary"
                color="brand.primary.mainContrast"
              >
                Try Talkio
              </Button>
            </Flex>
          </Box>
        </Flex>
      </Box>
    </>
  );
}

export async function getStaticProps({ params }: { params: { id: string } }) {
  const res = await fetch(`${cmsBaseLink}/posts?slug=${params.id}&_embed&per_page=100`);
  const posts = await res.json();
  const post = posts[0];
  const formattedDate = format(new Date(post.date), "MMMM dd, yyyy");

  return {
    props: {
      content: post.content.rendered,
      image: getWpImage(post, "full"),
      title: post.title.rendered,
      date: post.date,
      formattedDate,
    },
  };
}

export async function getStaticPaths() {
  const posts = await fetchWordPressPosts();
  const paths = posts.map((post: any) => ({
    params: { id: post.params.id },
  }));

  return {
    paths,
    fallback: false,
  };
}
